import { useEffect } from "react";

/**
 * Success toast notification that auto-dismisses.
 * Matches the app's dark theme styling.
 */
export default function SuccessToast({ message, onClose, duration = 3000 }) {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  return (
    <div
      style={{
        position: "fixed",
        top: 24,
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1100,
        animation: "slideDown 0.3s ease-out",
      }}
    >
      <div
        style={{
          backgroundColor: "#065f46",
          border: "1px solid #10b981",
          borderRadius: 12,
          padding: "16px 24px",
          display: "flex",
          alignItems: "center",
          gap: 12,
          boxShadow: "0 10px 40px rgba(0, 0, 0, 0.5)",
          maxWidth: 400,
        }}
      >
        {/* Success Icon */}
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            backgroundColor: "rgba(16, 185, 129, 0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: 20, height: 20, color: "#34d399" }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>

        {/* Message */}
        <div style={{ flex: 1 }}>
          <div style={{ color: "#6ee7b7", fontSize: 14, fontWeight: 500 }}>
            {message}
          </div>
        </div>

        {/* Close Button */}
        <button
          onClick={onClose}
          style={{
            background: "none",
            border: "none",
            color: "#6ee7b7",
            cursor: "pointer",
            padding: 4,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            opacity: 0.7,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ width: 18, height: 18 }}
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <style>{`
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
      `}</style>
    </div>
  );
}
